<h3>Warning!</h3>
<p><strong>{{idleState}}</strong></p>
<div class="closeButton">
    <button mat-raised-button color="accent" (click)="close()">do you want to continue </button>
</div>



// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/time-out-dialog/time-out-dialog.component.html